import { EditPopup } from './edit-popup';

type Props = {
  value: string;
  open: boolean;
  onSubmit: (plan: string) => void;
  onClose: VoidFunction;
};

export const EditYearlyResult = ({ value, open, onSubmit, onClose }: Props) => (
  <EditPopup
    title="Установить годовой план"
    value={value}
    onSubmit={onSubmit}
    onClose={onClose}
    open={open}
  />
);
